import React from "react";
import styled from "styled-components";
import { GetMoneyValue } from "../../../../Api/ApiCommon";
import { GetSubscriptionSetData } from "../../../../Api/ServiceDatas";
import { TableBodyItem } from "../../../Table/Table";
import { PayDetailTotalContainer } from "../PayInfo/PayInfoDetail";
import PartyFeePay from "../PayInfo/PayInfoDetail/PartyFeePay";
import { getSubsNameBySubsId3 } from "../../../../AdminApi/3.0_utils";

interface CalculatePayFailDetailProps {
  data: any;
}

export default function CalculatePayFailDetail({
  data,
}: CalculatePayFailDetailProps) {
  console.log(data);

  return (
    <>
      <PayDetailContainer>
        <PayDetailItem>
          {/* subscription 이름 */}
          <PayDetailItem>{getSubsNameBySubsId3(data?.subs)}</PayDetailItem>
        </PayDetailItem>
        <PayDetailItem></PayDetailItem>
        <PayDetailItem></PayDetailItem>

        {(data?.reason === 1 || data?.reason === 2) && (
          <PartyFeePay data={data} />
        )}

        <PayDetailItem></PayDetailItem>
        <PayDetailItem></PayDetailItem>
      </PayDetailContainer>

      {/* 합계 */}
      {data?.type !== 101 && (
        <PayDetailTotalContainer>
          <PayDetailItem></PayDetailItem>
          <PayDetailItem></PayDetailItem>
          <PayDetailItem></PayDetailItem>
          <PayDetailItem style={{ fontWeight: "bold" }}>합계</PayDetailItem>
          <PayDetailItem style={{ fontWeight: "bold" }}>
            {GetMoneyValue(data?.logdata?.amount)}
          </PayDetailItem>
          <PayDetailItem></PayDetailItem>
          <PayDetailItem></PayDetailItem>
        </PayDetailTotalContainer>
      )}
    </>
  );
}

const PayDetailContainer = styled.tr`
  padding-top: 10px;
  width: 100%;
  height: auto;
  background-color: #f5f5f5;
`;

const PayDetailItem = styled(TableBodyItem)`
  padding: 9px 10px;
  vertical-align: top;
`;
